import { css } from '@emotion/react';

import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import type { Interface } from './base';
import { Checkbox } from './base';

const QuestionnaireCheckbox = styled(Checkbox)(
	({
		theme: {
			questionnaireField: {
				checkboxes: {
					questionnaireAgreement: {
						checkboxBackgroundColor,
						checkboxColor,
						labelColor,
						labelFontSize,
						labelLineHeight,
						labelFontFamily,
						checkboxBorderColor,
						onFocusBorder,
					},
				},
			},
		},
	}: {
		theme: Theme;
	}) => css`
		color: ${labelColor};
		font-family: ${labelFontFamily};
		font-size: ${labelFontSize};
		line-height: ${labelLineHeight};
		margin-right: 10px;

		& > span {
			background-color: ${checkboxBackgroundColor};
			border-color: ${checkboxBorderColor};
		}

		& span::after {
			border-color: ${checkboxColor};
		}

		& > div {
			word-break: break-all;
		}
		input:focus ~ span {
			border-color: ${onFocusBorder};
		}
	`
);

const Wrapped = styled(({ className, ...checkboxProps }: Interface) => (
	<div className={className}>
		<QuestionnaireCheckbox {...checkboxProps} />
	</div>
))(
	({
		theme: {
			questionnaireField: {
				checkboxes: {
					questionnaireAgreement: { marginBottom, marginTop },
				},
			},
		},
	}: {
		theme: Theme;
	}) => ({
		marginBottom,
		marginTop,
	})
);

export { Wrapped as QuestionnaireCheckbox };
